import { FieldAttributes } from 'formik';
import { FC, useState } from 'react';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';

import { SolicitacaoDetalhada } from 'model/solicitacao/SolicitacaoDetalhada';

import { useSelector } from 'react-redux';
import { AvaliacaoCamposFormulario, AvaliacaoFormulario } from './formulario/AvaliacaoFormulario';
import { BotaoCancelar } from '../Botao/BotoesComuns';
import { ReaberturaCamposFormulario, ReaberturaFormulario } from './formulario/ReaberturaFormulario';
import { AvaliacaoSelector } from 'store/Avaliacao/Avaliacao.selector';
import { SolicitacaoFoiAtendidaField } from './formulario/SolicitacaoFoiAtendidaField';
import { useAppDispatch } from 'store/store';
import { AvaliacaoModalAction } from './action/AvaliacaoModalAction';


interface AvaliacaoModalProps extends FieldAttributes<any> {
  isOpen: boolean;
  solicitacao: SolicitacaoDetalhada;
  onClose: () => void;
}


export const AvaliacaoModal: FC<AvaliacaoModalProps> = ({isOpen, solicitacao, onClose}) => {
  const dispatch = useAppDispatch();
  const [atendida, setAtendida] = useState<boolean|undefined>(undefined);
  const isEnviandoRequisicao = useSelector(AvaliacaoSelector.formulario.isCarregando);

  const fecharModal = () => {
    setAtendida(undefined);
    onClose();
  }

  const onSubmitAvaliacao = async (formulario: AvaliacaoCamposFormulario) => {
    await dispatch(AvaliacaoModalAction.finalizarSolicitacao(solicitacao, formulario));
    fecharModal();
  }

  const onSubmitReabertura = async (formulario: ReaberturaCamposFormulario) => {
    await dispatch(AvaliacaoModalAction.reabrirSolicitacao(solicitacao, formulario));
    fecharModal();
  }

  return <ModalTransition>
    {isOpen && (
    <Modal
      onClose={fecharModal}
      heading="Avalie o nosso trabalho"
      scrollBehavior="inside"
      shouldCloseOnOverlayClick={!isEnviandoRequisicao}
      shouldCloseOnEscapePress={!isEnviandoRequisicao}
    >
      <p>As informações aqui prestadas ficarão disponíveis na página da solicitação.</p>
      <form>
        <SolicitacaoFoiAtendidaField onChange={setAtendida} valorInicial={atendida} />
        { atendida === undefined && <footer><BotaoCancelar type="button" onClick={fecharModal} /></footer> }
      </form>
      { atendida === true && <AvaliacaoFormulario onSubmit={onSubmitAvaliacao} onClose={fecharModal} /> }
      { atendida === false && <ReaberturaFormulario onSubmit={onSubmitReabertura} onClose={fecharModal} /> }
    </Modal>
    )}
  </ModalTransition>;
}


